module.exports = {
  current: "production",
};
//"staging", "production"
// qwerasdf147
